import { render, staticRenderFns } from "./AddTagDropdown.vue?vue&type=template&id=01c3e42e&scoped=true&"
import script from "./AddTagDropdown.vue?vue&type=script&lang=js&"
export * from "./AddTagDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c3e42e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/sivaram/work/carthike/whatsapp-crm-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01c3e42e')) {
      api.createRecord('01c3e42e', component.options)
    } else {
      api.reload('01c3e42e', component.options)
    }
    module.hot.accept("./AddTagDropdown.vue?vue&type=template&id=01c3e42e&scoped=true&", function () {
      api.rerender('01c3e42e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Common/AddTagDropdown.vue"
export default component.exports